import React from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { HiOutlineExclamation } from 'react-icons/hi';
import { FlexProps, Icon, Text, Button } from '@chakra-ui/react';
import { Card } from './Card';

interface ErrorCard extends FlexProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refetch: any;
  cardRef?: DraggableProvided['innerRef'];
  dragHandler?: DraggableProvided;
  cardOptions?: CardOptions;
}

export const ErrorCard: React.FC<ErrorCard> = ({ refetch, ...rest }) => {
  return (
    <Card {...rest} py="28px" align="center">
      <Icon
        borderRadius="100px"
        padding="16px"
        bg="grey.200"
        w="80px"
        h="80px"
        as={HiOutlineExclamation}
        color="grey.600"
      />
      <Text fontWeight="medium" color="text.100" fontSize="20px">
        Algo deu errado
      </Text>
      <Text color="text.300" fontSize="16px">
        Recarregue e tente novamente
      </Text>
      <Button
        mt="12px"
        fontSize="14px"
        w="98px"
        variant="outline"
        onClick={() => refetch()}
      >
        Recarregar
      </Button>
    </Card>
  );
};
